import React from 'react';
import style from './StartChatMessage.module.scss';
import useApp from 'hooks/useApp';
import ReactMarkdown from 'react-markdown';

interface Props {}

const StartChatMessgae: React.FC<Props> = props => {
    const { globalStartChatMessage } = useApp();
    const startNewChatMessage =
        globalStartChatMessage ??
        'To begin a new chat please return to the page you started it from.';

    return (
        <div className={style.container}>
            <ReactMarkdown className={style.text}>{startNewChatMessage}</ReactMarkdown>
        </div>
    );
};

export default StartChatMessgae;
